import Script from 'next/script'

const GoogleTagManager: React.FC = () => {
  return process.env.NODE_ENV === 'production' ? (
    <>
      <Script
        id='google-tag-manager-1'
        async
        src='https://www.googletagmanager.com/gtag/js?id=G-VP61MN2DDR'
      />
      <Script
        id='google-tag-manager-2'
        strategy='lazyOnload'
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MQ24J7KW');`,
        }}
      />
    </>
  ) : (
    <></>
  )
}

export default GoogleTagManager
